export default "__VITE_ASSET__ZAfainhL__"